// We receive information on the offer taking into account the current user and whether they took a trial before
export const getTrialOfferInfo = async (
  offer: string,
): Promise<{
  trial_offer: boolean;
  trial_period: number;
} | null> => {
  try {
    const response = await fetch(`/signup/i/trial_offer/?offer_hash=${offer}`);

    if (!response.ok) {
      console.error(`Error: Received status ${response.status}`);
      return null;
    }

    const offerData = await response.json();

    if (!offerData) {
      console.error('Error: Unexpected response format', offerData);
      return null;
    }

    if (offerData.error) {
      console.error(`Error from server: ${offerData.error}`);
      return null;
    }

    return {
      trial_offer: offerData.result,
      trial_period: offerData.trial_period,
    };
  } catch (e) {
    console.error('Error:', e);
    return null;
  }
};
